import type { ResolvedBetterstartConfig } from '@cli-types/core-engine/config.js'
import type { LoadedSchema } from '@cli-types/core-engine/schema-reader.js'
import { getSchemaOwner } from '@preset-engine/ownership/get-schema-owner.js'
import { runFormPipeline } from '@next-adapter/generators/form-pipeline/pipeline.js'
import { runEntityPipeline } from '@next-adapter/generators/run-entity-pipeline.js'
import { runSinglePipeline } from '@next-adapter/generators/run-single-pipeline.js'

export function runPipeline(
  loaded: LoadedSchema,
  cwd: string,
  config: ResolvedBetterstartConfig,
  options: { force: boolean }
) {
  const owner = getSchemaOwner(cwd, loaded.schema.name)
  const outputNamespace =
    owner === 'core'
      ? 'core'
      : owner?.startsWith('preset:')
        ? owner.replace(/^preset:/, '')
        : undefined

  if (loaded.type === 'form') {
    return runFormPipeline(loaded.schema, cwd, config, {
      force: options.force,
      silent: true,
      outputNamespace
    })
  }

  if (loaded.type === 'single') {
    return runSinglePipeline(loaded.schema, cwd, config, {
      force: options.force,
      silent: true,
      outputNamespace
    })
  }

  return runEntityPipeline(loaded.schema, cwd, config, {
    force: options.force,
    silent: true,
    outputNamespace
  })
}
